export enum Fee {
    All = 'all',
    None = 'none',
    Gold = 'gold',
    Silver = 'silver',
    Bronze = 'bronze',
}
